import { useState } from 'react';
import classNames from 'classnames';

export const Toggle = ({ label, toggled = false, onClick = () => {} }) => {
	const [isToggled, toggle] = useState(toggled);

	const callback = () => {
		toggle(!isToggled);
		onClick(!isToggled);
	};

	const classes = classNames('cfs-filters-toggle');

	return (
		<div className={classes}>
			<label>
				<input
					type="checkbox"
					defaultChecked={isToggled}
					onClick={callback}
				/>
				<span />
				<strong>{label}</strong>
			</label>
		</div>
	);
};
